import HiddenInputs from './HiddenInputs';

export { HiddenInputs };
